import React from 'react';
import styled from 'styled-components';

import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import EmptyPageLayout from 'src/presentation/components/pages/shared/EmptyPageLayout';
import { H2 } from '@ad-scripts/presentation/components/common/headers';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import VoiceFillIcon from '@ad-scripts/presentation/components/common/icons/fill/voice-fill';

const VoiceEmptyPage = ({ handleSetUpVoice }): JSX.Element => {
  return (
    <EmptyPageLayout data-aid="empty-voice-page">
      <StyledVoiceFillIcon />
      <H2 data-aid="header-title">Get started with voice</H2>
      <EmptyPageDescription data-aid="header-description">
        Configure and manage your voice setup to start interacting with customers over phone. Read{' '}
        <ExternalLink
          data-aid="set-up-voice-help-link"
          label="Set Up Voice"
          to="https://help.gladly.com/implementation/docs/set-up-voice-ivr"
        />{' '}
        to learn more.
      </EmptyPageDescription>
      <Button data-aid="action-button-set-up-voice" onClick={handleSetUpVoice} buttonType={ButtonTypes.PRIMARY}>
        Set up voice
      </Button>
    </EmptyPageLayout>
  );
};

const StyledVoiceFillIcon = styled(VoiceFillIcon)`
  fill: ${({ theme }) => theme.colors.gray600};
  margin-bottom: 20px;
  width: 40px;
`;

const EmptyPageDescription = styled.div`
  margin-bottom: 24px;
  max-width: 460px;
  text-align: center;
`;

export default VoiceEmptyPage;
